import {
  VStack,
  Text,
  Spinner,
} from "@chakra-ui/react";
import styled from "styled-components";
import { Campaign } from "../../api/admin/adminCampaign";
import { CampaignWizard } from "./CampaignWizard";
import { CampaignEditForm } from "./CampaignEditForm";

const Container = styled.div`
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

interface Props {
  campaign: Campaign | null;
  selectedClientId: string;
  isIndividualClient?: boolean;
  onCampaignUpdate: (campaign: Campaign | null) => void;
  aiSuggestions?: any;
  onSuggestionsApplied?: () => void;
  isLoading?: boolean;
}

export const CampaignDetailsPanel = ({
  campaign,
  selectedClientId,
  isIndividualClient = false,
  onCampaignUpdate,
  aiSuggestions,
  onSuggestionsApplied,
  isLoading = false,
}: Props) => {

  if (!selectedClientId) {
    return (
      <Container>
        <Text color="gray.500">
          Select a client to start building a campaign
        </Text>
      </Container>
    );
  }

  if (isLoading) {
    return (
      <Container>
        <VStack spacing={4} align="center" justify="center" minH="300px">
          <Spinner size="xl" color="#339CFF" />
          <Text color="gray.500">Loading campaign...</Text>
        </VStack>
      </Container>
    );
  }

  // Show wizard for new campaigns, edit form for existing
  if (!campaign) {
    return (
      <CampaignWizard
        selectedClientId={selectedClientId}
        isIndividualClient={isIndividualClient}
        onCampaignCreated={onCampaignUpdate}
        aiSuggestions={aiSuggestions}
        onSuggestionsApplied={onSuggestionsApplied}
      />
    );
  }

  return (
    <CampaignEditForm
      campaign={campaign}
      selectedClientId={selectedClientId}
      onCampaignUpdate={onCampaignUpdate}
    />
  );
};
